import { parseMonthYear } from 'features/common/datetimeUtils';
import { capitalizeFirstLetter } from 'features/common/utils';

export function pathForSearchParams(searchParams) {
  const path = `${window.location.pathname}?${searchParams.toString()}`;
  return path;
}

//  pure js to rewrite url in place, no hooks attached
export function replaceOrPushURLParam(searchParams, pushOnChangeTo: string[]) {
  const newRelativePathQuery = pathForSearchParams(searchParams);
  const currentSearchParams = new URLSearchParams(window.location.search);
  // console.log(currentSearchParams, searchParams);
  let shouldPush = false;
  for (let i = 0; i < pushOnChangeTo.length; i++) {
    const key = pushOnChangeTo[i];
    // Only push if we previously had this key and it has now changed
    // This is slightly strange logic but it prevents pushing a load of history on app reload where state is being trickled in from components
    if (
      !!currentSearchParams.get(key) &&
      currentSearchParams.get(key) !== searchParams.get(key)
    ) {
      // console.log(key, currentSearchParams.get(key), searchParams.get(key));
      shouldPush = true;
    }
  }
  const currentSearchString = window.location.search
    .toString()
    .replace('?', '');
  if (searchParams.toString() !== currentSearchString) {
    // console.log(shouldPush, newRelativePathQuery);
    if (shouldPush) {
      window.history.pushState(null, '', newRelativePathQuery);
    } else {
      window.history.replaceState(null, '', newRelativePathQuery);
    }
  } else {
    // console.log('Updating duplicate url entry, skipping');
  }
}

export function resetURLParams() {
  // console.log(`resetURLParams`);
  window.history.pushState(null, '', window.location.pathname);
}

export function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item);
}

export function optionallyCall(value, args) {
  if (typeof value === 'function') {
    return value(args);
  } else {
    return value;
  }
}

export function sortTypicalMonths(typicalMonths) {
  const months = [...typicalMonths];
  months.sort(
    (a, b) =>
      parseMonthYear(a.typicalMonth).valueOf() -
      parseMonthYear(b.typicalMonth).valueOf(),
  );
  return months;
}
//TODO: replace with BE
export function getShortId(id: string): string {
  let hash1 = 5381;
  let hash2 = 52711;

  for (let i = 0; i < id.length; i++) {
    const ch = id.charCodeAt(i);
    hash1 = (hash1 * 33) ^ ch;
    hash2 = (hash2 * 33) ^ ch;
  }

  return ((hash1 >>> 0).toString(36) + (hash2 >>> 0).toString(36)).slice(0, 10);
}

// pluralize a word based on count
export function pluralize(count: number, word: string): string {
  return count !== 1 ? `${word}s` : word;
}
export const isMac = navigator.userAgent.includes('Mac');

export const SOMETHING_WENT_WRONG_SAVING_MSG =
  'Something went wrong while saving';

export const getSavedSuccessMsg = (item: string) =>
  `${capitalizeFirstLetter(item)} saved successfully`;
